import { Controller } from "@hotwired/stimulus"
import { application } from "~/controllers/application"
import Rails from "@rails/ujs"
import $ from "jquery"

application.register("column-modal", class extends Controller {
  static targets = ["form", "insertPlacementSelect", "insertPositionSelect"]

  submit(e) {
    e.preventDefault();

    const controller = this;
    const insertPlacement = $(this.insertPlacementSelectTarget).val();
    const insertPosition = parseInt($(this.insertPositionSelectTarget).val());

    if(insertPlacement && insertPosition) {
      const position = insertPlacement == "before" ? insertPosition - 1 : insertPosition + 1;
      $(this.formTarget).append(`<input type="hidden" name="column[column_order_position]" value="${position}">`);
    }

    $.post(`${$(this.formTarget).attr("action")}.json`, `${$(this.formTarget).serialize()}&${$.param({authenticity_token: Rails.csrfToken()})}`, function(response) {
      if(response.code) {
        const gridController = application.getControllerForElementAndIdentifier(window.document.getElementById("grid"), "grid");
        const modalController = application.getControllerForElementAndIdentifier(controller.element, "modal");

        gridController.columns = response.data.columns
        gridController.gridApi.setGridOption("columnDefs", gridController.columns)

        modalController.close(e);
      }
    }).fail(function() {

    });
  }
});
